import { Seat } from '@core/models';
import {
  ANALYTICS_ITEM_CATEGORIES,
  AnalyticsItem,
} from '@core/services/analytics';

export function buildCartItems(
  seats: Seat[],
  gameId: string,
  matchup: string
): AnalyticsItem[] {
  const seatsBySection = new Map<string, Seat[]>();
  for (const seat of seats) {
    const sectionSeats = seatsBySection.get(seat.section) ?? [];
    sectionSeats.push(seat);
    seatsBySection.set(seat.section, sectionSeats);
  }

  const items: AnalyticsItem[] = [];
  for (const [section, sectionSeats] of seatsBySection) {
    const firstSeat = sectionSeats[0];
    items.push({
      itemId: `${gameId}::${section}`,
      itemName: `${matchup} - ${section}`,
      itemCategory: ANALYTICS_ITEM_CATEGORIES.SEATS,
      price: firstSeat.price,
      quantity: sectionSeats.length,
    });
  }
  return items;
}
